<script>
// import { getSubscribersList } from "@/api/subscribers";
import {
  getSegments,
  createCampaignBySendgrid,
  updateCampaignBySendgrid
} from "@/api/campaigns";
import swal from "sweetalert";
import moment from "moment";
import {Datetime} from "vue-datetime";

export default {
  name: "add-campaigns-modal",
  components: {
    Datetime,
  },
  props: {
  },
  data() {
    return {
      form: {
        id: '',
        name: "",
        automation_id: "",
        segment_id: null,
        date:{
          start:  moment().format("YYYY-MM-DD"),
          end:  moment().format("YYYY-MM-DD")
        },
      },
      minDate: moment().format("YYYY-MM-DD"),
      segments: [],
      disabled: false,
      btnTxt: "Add Campaign",
      btnTxtSend: "Send Campaign",
      emails: [],
      snackbar: false,
      text: "",
      timeout: 2000,
      redirected: false,
      redirectedDisabled: false,
      submitTxt: "Create my Campaign",
      isUpdate: false,
      dateUpdate: {}
    };
  },
  async mounted() {
    let response = null;
    //Fetch segments
    response = await getSegments();
    if (response && response.length > 0) {
      this.segments = response;
    } else {
      this.snackbar = true;
      this.text = "Fetching of segment list. Returns empty response";
    }
  },
  watch:{
    "redirected"(){
      let segmentData = this.segments
      let keyHold = ''
      console.log('--redirected..')
      if(segmentData.length ){
        keyHold = segmentData.length - 1
        segmentData = segmentData[keyHold]
        this.form.name = segmentData.name
        this.form.segment_id = segmentData.id
        this.redirectedDisabled = true
      }
    }
  },
  computed: {
    segmentsOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.segments.map(list => {
          return {
            value: list.id,
            text: list.name
          };
        })
      ];
    }
  },
  methods: {
    showModal(){
      this.resetFields()
      this.redirected = true
      this.$refs["modal-add-sendgrid-campaign"].show();
    },
    showUpdadeModeModal(data = ''){
      this.resetFields()
      this.dateUpdate = data
      console.log('---: ',data)
      this.isUpdate = true
      this.$refs["modal-add-sendgrid-campaign"].show();
      if (data != ''){ // UPDATE PART
        this.form.name = data.name
        this.form.date.start = moment(data['date_start']).format("YYYY-MM-DD")
        this.form.date.end = moment(data['date_ended']).format("YYYY-MM-DD")
        this.form.segment_id = data['segment_id']
        this.submitTxt = 'Save Changes'
      }
    },
    resetFields(){
      this.form.name = ''
      this.form.date.start = moment().format("YYYY-MM-DD")
      this.form.date.end = moment().format("YYYY-MM-DD")
      this.form.segment_id = null
      this.redirectedDisabled= false
      this.submitTxt= "Create my Campaign"
      this.isUpdate= false
      this.dateUpdate = {}
    },
    async onSubmit() {
      this.submitTxt = "Loading..."
      let collection = {
        name: this.form.name,
        date_start: this.form.date.start,
        date_ended: this.form.date.end,
        segment: this.form.segment_id,
        campaign_type: 'sendgrid'
      }

      if (this.form.automation_id != ''){
        collection['automation_id'] = this.form.automation_id
      }

      const payload = JSON.parse(
        JSON.stringify(collection)
      );
      if(this.isUpdate){
        this.dateUpdate['name'] = this.form.name
        this.dateUpdate['date_start'] = this.form.date.start
        this.dateUpdate['date_ended'] = this.form.date.end
        this.dateUpdate['segment'] = this.form.segment_id
        
        const payloadUpdate = JSON.parse(
          JSON.stringify(this.dateUpdate)
        );
        try {
          let response = await updateCampaignBySendgrid(payloadUpdate)
          if(response){
            swal({
              title: "Great",
              text: "Succesfully updated!",
              icon: "success",
              button: "Okay",
            }).then(() => {
              this.resetFields()
              this.$store.dispatch("getCampaignList");
              this.$refs["modal-add-sendgrid-campaign"].hide();
              this.$router.push(`/campaigns`);
              this.submitTxt = "Campaign succesfuly updated!"
              // window.location.href='/campaigns'
            })
          }
        } catch (error) {
          swal({
            title: "Sorry",
            text: "Something went wrong. Please try again later.",
            icon: "info",
            button: "Okay",
          })
        }
      }else{
        try {
          let response = await createCampaignBySendgrid(payload)
          if(response){
            swal({
              title: "Great",
              text: "Succesfully created!",
              icon: "success",
              button: "Okay",
            }).then(() => {
              this.resetFields()
              this.$store.dispatch("getCampaignList");
              this.$refs["modal-add-sendgrid-campaign"].hide();
              this.$router.push(`/campaigns`);
              this.submitTxt = "Create my Campaign"
              // window.location.href='/campaigns'
            })
          }
        } catch (error) {
          swal({
            title: "Sorry",
            text: "Something went wrong. Please try again later.",
            icon: "info",
            button: "Okay",
          })
        }
      }

      
      

    }
  }
};
</script>

<template>
  <b-modal
    id="modal-add-sendgrid-campaign"
    ref="modal-add-sendgrid-campaign"
    title="Create Campaign using Email Service Provider"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
  >
    <b-form
      v-on:submit.prevent="onSubmit"
      method="POST"
      accept-charset="UTF-8"
      enctype="multipart/form-data"
      id="mainForm-addCampaign"
    >
      <b-form-group
        id="input-group-campaign-name"
        label="Campaign Name:"
        class="fbold"
        label-for="input-campaign-name"
      >
        <b-form-input
          id="input-campaign-name"
          v-model="form.name"
          type="text"
          maxlength="50"
          required
          placeholder="Campaign name"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-automation-id-lbl"
        label="Automation ID:"
        class="fbold"
        label-for="input-automation-id"
      >
        <b-form-input
          id="input-automation-id"
          v-model="form.automation_id"
          maxlength="50"
          type="text"
          placeholder="Sendgrid Automation ID"
        ></b-form-input>
      </b-form-group>
      <b-row class="mb-2">
          <b-col>
            <div class="sublabel">From</div>
              <datetime
                input-class="form-control"
                format="yyyy-MM-dd"
                v-model="form.date.start"
                :min-datetime="minDate"
                value-zone="local"
                zone="local"
            ></datetime>
          </b-col>
          <b-col>
            <div class="sublabel">To</div>
            <datetime
                input-class="form-control"
                format="yyyy-MM-dd"
                v-model="form.date.end"
                :min-datetime="minDate"
                value-zone="local"
                zone="local"
            ></datetime>
          </b-col>
      </b-row>

      <b-form-group
        id="input-group-segment-list"
        label="Segments:"
        label-for="select-segment_list_id"
      >
        <v-select
          class="segment_list"
          v-model="form.segment_id"
          :items="segmentsOptions"
          :disabled="redirectedDisabled"
          required
          dense
          outlined
          height="22"
          :menu-props="{ top: false, offsetY: true }"
        ></v-select>
      </b-form-group>
      <b-form-group class="campaign-btn-cont">
        <b-button
          type="submit"
          class="float-right campaign-btns"
          :disabled="disabled"
          variant="primary"
        >
          {{submitTxt}}
        </b-button>
      </b-form-group>
    </b-form>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </b-modal>
</template>

<style scoped>
.campaign-btn-cont {
  margin: 10px;
  width: 100%;
}
.campaign-btns {
  margin: 10px;
}
.segment_list{
  font-size: 1rem;
  height: 30px;
}
</style>
